<sc-padding fitHeight leftRightOnly noFieldSpace>
  <sc-paged-content [data]="transportOption?.parameter" [configuration]="configuration"
    (selectionChanged)="onSelectionChanged($event)" (addRequested)="onAddParameter($event)"
    [selected]="currentTransportOptionParameter" (deleteRequested)="onDeleteParameter($event)">

    <sc-no-data-container fitHeight [hasData]="currentTransportOptionParameter">

      <sc-flex vertical fitHeight stretchContent>

        <div [formGroup]="formGroup">

          <sc-flex [gap]="16">

            <sc-dictionary-field grow [model]="currentTransportOptionParameter?.name" [maxlength]="255"
              defaultLabel="Name" labelDictionaryKey="tmc-yard.control.entity.transport-option-parameter.name"
              (dictionaryChanged)="onParameterNameChanged($event)" [disabled]="!currentTransportOptionParameter">
            </sc-dictionary-field>

            <sc-string-field formControlName="sortOrder"
              labelDictionaryKey="tmc-yard.control.entity.transport-option-parameter.sortOrder">
            </sc-string-field>

          </sc-flex>

          <sc-content-spacer half vertical></sc-content-spacer>

          <sc-select-field formControlName="type" [data]="options"
            labelDictionaryKey="tmc-yard.control.entity.transport-option-parameter.type"></sc-select-field>

          @if (currentTransportOptionParameter?.type === 'TEXT') {

          <sc-content-spacer vertical half></sc-content-spacer>

          <sc-text-field formControlName="minLength"
            labelDictionaryKey="tmc-yard.control.entity.transport-option-parameter.minLength"></sc-text-field>

          }

          <sc-content-spacer vertical half></sc-content-spacer>

          <sc-flex wrap [gap]="16">
            <sc-sized-container [minWidth]="250">
              <sc-checkbox-field formControlName="showInTerminal"
                labelDictionaryKey="tmc-yard.control.entity.transport-option-parameter.showInTerminal"></sc-checkbox-field>
              <sc-content-spacer vertical half></sc-content-spacer>
              <sc-checkbox-field formControlName="mandatoryInTerminal"
                labelDictionaryKey="tmc-yard.control.entity.transport-option-parameter.mandatoryInTerminal"></sc-checkbox-field>


            </sc-sized-container>
            <sc-sized-container [minWidth]="250">
              <sc-checkbox-field formControlName="showInTime"
                labelDictionaryKey="tmc-yard.control.entity.transport-option-parameter.showInTime"></sc-checkbox-field>
              <sc-content-spacer vertical half></sc-content-spacer>
              <sc-checkbox-field formControlName="mandatoryInTime"
                labelDictionaryKey="tmc-yard.control.entity.transport-option-parameter.mandatoryInTime"></sc-checkbox-field>

            </sc-sized-container>
          </sc-flex>

        </div>

        @if (currentTransportOptionParameter?.type !== 'TEXT') {

        <sc-content-spacer vertical></sc-content-spacer>

        <sc-sub-title>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.parameter-values"></sc-dictionary-label>
        </sc-sub-title>

        <sc-content-spacer vertical half></sc-content-spacer>

        <sc-flex-fitting-content vertical>
          <sc-scroll-pane>
            @for (value of currentTransportOptionParameter?.values; track value; let i = $index) {
            @if (i > 0) {
            <sc-content-spacer [half]="true" vertical></sc-content-spacer>
            }
            <sc-data-set-tile [light]="i % 2 === 0" [selected]="currentEditingParameterValue === value">
              <sc-padding>
                @if (currentEditingParameterValue == null || currentEditingParameterValue !== value) {
                <sc-flex>
                  <app-dictionary-entry-label [model]="value.value"></app-dictionary-entry-label>
                  <sc-content-spacer grow></sc-content-spacer>
                  <sc-action-icon iconClass="fa-pencil" (click)="editParameterValue(value)"></sc-action-icon>
                  <sc-content-spacer></sc-content-spacer>
                  <sc-action-icon iconClass="fa-trash" (click)="deleteParameterValue(value)"></sc-action-icon>
                </sc-flex>
                }
                @if (currentEditingParameterValue === value) {
                <form class="no-field-space">
                  <sc-flex>
                    <sc-dictionary-field grow [model]="currentEditingParameterValue.value" [maxlength]="255"
                      defaultLabel="Wert"
                      labelDictionaryKey="tmc-yard.ui.admin.transport-options-administration.parameter-value"
                      (dictionaryChanged)="onParameterValueChanged($event)">
                    </sc-dictionary-field>
                    <sc-content-spacer></sc-content-spacer>
                    <sc-icon iconClass="fa-times" (click)="unselectParameterValue()"></sc-icon>
                  </sc-flex>
                </form>
                }
              </sc-padding>
            </sc-data-set-tile>
            }
          </sc-scroll-pane>
        </sc-flex-fitting-content>
        <sc-content-spacer vertical></sc-content-spacer>
        <div>
          <sc-flex [centered]="true">
            <sc-add-action-button [disabled]="!currentTransportOptionParameter" large
              (click)="addParameterValue()"></sc-add-action-button>
          </sc-flex>
        </div>
        }
      </sc-flex>
    </sc-no-data-container>
  </sc-paged-content>
</sc-padding>
